import { Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import '../App.css';
import '../js/common.js';
import hearts1 from './img/icons/hearts1.png';
import hearts2 from './img/icons/hearts2.png';
import hearts7 from './img/icons/hearts7.png';
import letter from './img/content/letter.png';
import cta from './img/content/cta.svg';

function HomePage() {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [modalOpen, setModalOpen] = useState(null);
  var detectCurrentDevice = localStorage.getItem('deviceDetected');
  const fromWizard = localStorage.getItem('fromWizard');
  localStorage.setItem("cookieModal", "close");
  if (fromWizard === "true") {
    localStorage.setItem("hideBoxTitle", "false");
    localStorage.setItem("fromWizard", "false");
  }

  useEffect(() => {

    const womenButton = document.getElementById('womenEvent');
    const menButton = document.getElementById('menEvent');
    const readLetter = document.getElementById('readLetterEvent');

    womenButton.addEventListener('touchend', (event) => {
      event.preventDefault();
      handleWomenClick();
    });

    menButton.addEventListener('touchend', (event) => {
      event.preventDefault();
      handleMenClick();
    });

    readLetter.addEventListener('touchend', (event) => {
      event.preventDefault();
      openLetterClick();
    });

    window.tc_vars = {
      'channel': detectCurrentDevice,
      'environment': "stg",
      'pagetemplate': "Valentino Lovely Courting Experience: Homepage",
      'site_languagecode': currentLanguage,
      '404': false,
      'pagename': "V:" + currentLanguage + ":valentine:homepage"
    };
    window._satellite.track('virtual_page_load');
    console.log("tc_vars", window.tc_vars);
    console.log("virtual_page_load", "activated");
  }, []);

  const handleWomenClick = () => {
    localStorage.setItem('selectedGender', 'WOMEN');
    setModalOpen("#letters");
    document.body.classList.add('modal-expanded', 'letters-expanded');
    window._satellite.track('digitalcatalog', {
      event: 'click_select_gender',
      eventLabel: 'WOMEN'
    });
    console.log("window._satellite.track", "click_select_gender: WOMEN");
  };
  
  const handleMenClick = () => {
    localStorage.setItem('selectedGender', 'MEN');
    setModalOpen("#letters");
    document.body.classList.add('modal-expanded', 'letters-expanded');
    window._satellite.track('digitalcatalog', {
      event: 'click_select_gender',
      eventLabel: 'MEN'
    });
    console.log("window._satellite.track", "click_select_gender: MEN");
  };

  const openLetterClick = () => {
    setModalOpen("#letter");
    document.body.classList.add('letter-expanded');
    const modalLetter = document.getElementById('letter');
    if (modalLetter) {
      modalLetter.classList.add('is-open');
    }
    window._satellite.track('digitalcatalog', {
      'event': 'read_the_letter'
    });
    console.log("window._satellite.track", "read_the_letter");
  };

  const discoverGiftClick = () => {
    window._satellite.track('digitalcatalog', {
      'event': 'discover_the_gift'
    });
    console.log("window._satellite.track", "discover_the_gift");
  }
  
  return (
    <div className="App">
      <div className="wrapper">
        <div className="wrap">
          <div className="container">
            <div className="main">
              
              <div>
                <h1>
                  <span>LOVELY</span>
                  <br/>COURTING
                </h1>
            </div>
              
              <div className="main__content">
                <p>
                  {t('FIRST_FRASE_HOMEPAGE')}<br />
                  {t('SECOND_FRASE_HOMEPAGE')}
                </p>
                <div className="main__actions">
                  <div className="main__item">
                    <a
                      href="/#letters"
                      id="womenEvent"
                      className="main__btn btn btn--red js-open-modal"
                      data-modal="#letters"
                      onClick={handleWomenClick}
                    >
                      {t('WOMEN_LABEL_HOMEPAGE')}
                    </a>
                  </div>
                  <div className="main__item">
                    <a
                      href="/#letters"
                      id="menEvent"
                      className="main__btn btn btn--red js-open-modal"
                      data-modal="#letters"
                      onClick={handleMenClick}
                    >
                    {t('MAN_LABEL_HOMEPAGE')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div className="hearts">
            <div className="hearts__item hearts__item--1">
              <picture className="hearts__img">
                <img src={hearts1} width={63} height={54} alt="" />
              </picture>
            </div>
            <div className="hearts__item hearts__item--2">
              <picture className="hearts__img">
                <img src={hearts2} width={53} height={55} alt="" />
              </picture>
            </div>
            <div className="hearts__item hearts__item--2">
              <picture className="hearts__img">
                <img src={hearts2} width={53} height={55} alt="" />
              </picture>
            </div>
          </div>
          <div className="modal modal--letters" id="letters">
            <div className="modal-content">
              <div className="modal-content__letters modal-content-letters">
                <div className="modal-content-letters__wrap-img">
                  <picture className="modal-content-letters__img modal-content-letters__img--1">
                    <img src={letter} width={601} height={458} alt="" />
                  </picture>
                  <a
                    href="/#letter"
                    id="readLetterEvent"
                    className="modal-content-letters__cta js-open-modal"
                    data-modal="#letter"
                    onClick={openLetterClick}
                  >
                    <picture className="modal-content-letters__cta-img">
                      <img src={cta} width={173} height={173} alt="" />
                    </picture>
                  </a>
                </div>
                <picture className="modal-content-letters__img modal-content-letters__img--2">
                  <img src={letter} width={601} height={458} alt="" />
                </picture>
                <picture className="modal-content-letters__img modal-content-letters__img--3">
                  <img src={letter} width={601} height={458} alt="" />
                </picture>
                <picture className="modal-content-letters__img modal-content-letters__img--4">
                  <img src={letter} width={601} height={458} alt="" />
                </picture>
                <picture className="modal-content-letters__img modal-content-letters__img--5">
                  <img src={letter} width={601} height={458} alt="" />
                </picture>
                <picture className="modal-content-letters__img modal-content-letters__img--6">
                  <img src={letter} width={601} height={458} alt="" />
                </picture>
              </div>
            </div>
          </div>
          <div className="modal modal--letter" id="letter">
            <div className="wrap-modal">
              <div className="modal-content">
                <picture>
                <img src={hearts7} width={39} height={35} alt="" />
                </picture>
                <h2>{t('SWEETHEART_WORD_LABEL')},</h2>
                <p>
                  {t('LETTER_FIRST_PARAGRAPH')}
                </p>
                <p>
                  {t('LETTER_SECOND_PARAGRAPH')}
                </p>
                <p>
                  {t('LETTER_THIRD_PARAGRAPH')}
                </p>
              </div>
              <div className="modal-actions">
                <Link to="/box" className="modal-actions__btn btn btn--red js-go-page" onClick={discoverGiftClick}>{t('DISCOVER_GIFT_LABEL_CTA')}</Link>
              </div>
            </div>
          </div>
      <div className="overflow-bg" /></div>
  </div>
  );
}

export default HomePage;